import { createUseStyles } from '@glu/theming';

const styles = ({ schedulerReact }) => ({
  monthly: {
    marginBottom: 20
  },
  monthSelect: {
    display: 'inline-block',
    width: 60,
    margin: '0 5px'
  },
  dates: {
    marginBottom: -20
  },
  removeBtn: {
    padding: [7, 5],
    marginLeft: 10,
    '& svg': {
      fill: 'white',
      top: 2,
      position: 'relative'
    }
  },
  addBtn: {
    marginTop: 20,
    ...schedulerReact.addButton
  },
  addBtnText: {
    ...schedulerReact.addBtnText
  },
  addBtnIcon: {
    ...schedulerReact.addBtnIcon
  }
});

export default createUseStyles(styles);
